var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85888 6.49975L9.44437 3.91427C9.83489 3.52374 9.91404 2.96972 9.62114 2.67683C9.32825 2.38394 8.77423 2.46308 8.38371 2.85361L5.55528 5.68203C5.31199 5.92532 5.18955 6.23207 5.20262 6.4996C5.18945 6.7672 5.31189 7.07408 5.55527 7.31746L8.38369 10.1459C8.77422 10.5364 9.32824 10.6156 9.62113 10.3227C9.91402 10.0298 9.83488 9.47575 9.44435 9.08522L6.85888 6.49975Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.2fb16f13bf1551cd0c33972b8178fd8e.svg";
export { ForwardRef as ReactComponent };